module.exports = "/../../dist/frontend/images/agency-pin-available-pro.png?b7cc105fb3cef1a8fa508278f2590036";